// src/components/ReviewSlider.jsx
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './ReviewSlider.css';

// 国コードから国名を取得（多言語対応）
const getCountryName = (code, isEnglish) => {
    const names = {
        gb: { ja: 'イギリス', en: 'United Kingdom' },
        za: { ja: '南アフリカ', en: 'South Africa' },
        sg: { ja: 'シンガポール', en: 'Singapore' },
        ch: { ja: 'スイス', en: 'Switzerland' },
        au: { ja: 'オーストラリア', en: 'Australia' },
        cz: { ja: 'チェコ', en: 'Czech Republic' },
        br: { ja: 'ブラジル', en: 'Brazil' },
        jp: { ja: '日本', en: 'Japan' },
        us: { ja: 'アメリカ', en: 'United States' },
        fr: { ja: 'フランス', en: 'France' },
        cn: { ja: '中国', en: 'China' },
        tw: { ja: '台湾', en: 'Taiwan' },
        kr: { ja: '韓国', en: 'South Korea' },
        de: { ja: 'ドイツ', en: 'Germany' },
    };
    const country = names[code.toLowerCase()];
    if (!country) return code.toUpperCase();
    return isEnglish ? country.en : country.ja;
};

// レビューデータ（変更なし）
const reviews = [
    {
        score: 10, countryCode: 'gb', guests: 4,
        ja: { date: '2026年1月', title: '最高の滞在', content: '伝統的で美しい古い家。完璧な清潔さ。非常に広々としたキッチンとバスルームには、必要なアメニティがすべて揃っています。フレンドリーなオーナーで、チェックイン手続きもとても簡単です。' },
        en: { date: 'Jan 2026', title: 'Perfect Stay', content: 'A beautiful traditional old house. Perfectly clean. Very spacious kitchen and bathroom with all necessary amenities. Friendly owner and very easy check-in process.' }
    },
    {
        score: 10, countryCode: 'za', guests: 6,
        ja: { date: '2025年12月', title: '伝統と現代の融合', content: '伝統と現代が融合した素晴らしい宿泊施設です。本当に気に入りました。ホストの細部への配慮は素晴らしい。美しい家です。' },
        en: { date: 'Dec 2025', title: 'Fusion of Tradition and Modernity', content: 'A wonderful accommodation where tradition meets modernity. We absolutely loved it. The host\'s attention to detail is amazing. A beautiful house.' }
    },
    {
        score: 10, countryCode: 'jp', guests: 3,
        ja: { date: '2024年12月', title: '非日常の空間', content: '庭園や建築美から生まれる非日常の空間。冬ならではの「こたつ」が用意されており、温かく快適に過ごすことが出来ました。また広大な庭園をお風呂から眺めることができるのも魅力的です。' },
        en: { date: 'Dec 2024', title: 'An Extraordinary Space', content: 'An extraordinary space created by the garden and architectural beauty. The "Kotatsu" provided for winter made our stay warm and comfortable. Looking out at the vast garden from the bath was also charming.' }
    },
    {
        score: 10, countryCode: 'sg', guests: 8,
        ja: { date: '2025年11月', title: '家族連れならここに泊まるべき', content: 'その家は日本式の家です。本物の日本の家での暮らしを体験するためにどこかへ行く必要はありません。何もない。すべてが良かった。' },
        en: { date: 'Nov 2025', title: 'Perfect for Families', content: 'It is a true Japanese-style house. You don\'t need to go anywhere else to experience living in an authentic Japanese home. Everything was perfect.' }
    },
    {
        score: 10, countryCode: 'au', guests: 7,
        ja: { date: '2025年11月', title: '今までで最高の宿泊施設', content: 'あけぼのは、明治時代の貴族の都会の邸宅を完璧に復元したものです。本当に素晴らしく、信じられないほど快適で、手入れが行き届いており、設備も素晴らしく、立地も完璧です。' },
        en: { date: 'Nov 2025', title: 'Best Accommodation Ever', content: 'Akebono is a perfect restoration of a Meiji-era aristocratic urban residence. Truly magnificent, incredibly comfortable, well-maintained, excellently equipped, and in a perfect location.' }
    },
    {
        score: 10, countryCode: 'ch', guests: 5,
        ja: { date: '2025年7月', title: '日本での最高の滞在', content: '細部まで素晴らしい木製パネル、畳の床、和紙の障子に囲まれたこの美しい伝統的な日本家屋に泊まるのは素晴らしい体験でした。まるでタイムスリップして侍の家に泊まっているような気分でした。' },
        en: { date: 'Jul 2025', title: 'Best Stay in Japan', content: 'Staying in this beautiful traditional Japanese house surrounded by exquisite wood paneling, tatami floors, and washi screens was an amazing experience. It felt like time traveling to a samurai residence.' }
    },
    {
        score: 10, countryCode: 'jp', guests: 6,
        ja: { date: '2025年2月', title: '金沢の真ん中で家族でゆったり', content: 'とにかく広く、清潔感があり、快適でした。向かいが学校なので夜もとても静かで、美術館や工芸館も徒歩圏内で散歩できました。子連れ3家族で宿泊しましたが、それぞれの家族のスペース確保でき大満足でした。' },
        en: { date: 'Feb 2025', title: 'Relaxing Family Time in Kanazawa', content: 'Spacious, clean, and comfortable. It was very quiet at night, and museums were within walking distance. We stayed with three families with children, and everyone had enough space. Highly satisfied.' }
    },
    {
        score: 10, countryCode: 'br', guests: 4,
        ja: { date: '2025年3月', title: '素晴らしい宿泊施設です！', content: '素晴らしい家で、とても清潔で居心地がよかったです。ホストはとても親切で協力的でした。家自体は歴史と現代性が融合した素晴らしい雰囲気で、完璧な滞在に必要なものがすべて揃っています。' },
        en: { date: 'Mar 2025', title: 'Wonderful Accommodation!', content: 'An amazing house, very clean and cozy. The host was very kind and supportive. The house has a wonderful atmosphere blending history and modernity, with everything needed for a perfect stay.' }
    },
    {
        score: 10, countryCode: 'cz', guests: 3,
        ja: { date: '2025年7月', title: 'とても日本的な家', content: '素晴らしい、とても日本的な家です。そこに住んでいると、サムライハウスに行く必要はありません。市内中心部や訪れるべき興味深いスポットはすべて徒歩圏内です。' },
        en: { date: 'Jul 2025', title: 'Very Japanese House', content: 'A wonderful, very Japanese house. Living there, you don\'t need to visit a samurai house museum. The city center and interesting spots are all within walking distance.' }
    },
    {
        score: 10, countryCode: 'jp', guests: 8,
        ja: { date: '2025年2月', title: '素晴らしい!!', content: '町屋敷に泊まれるとは夢にも思わなかったですが、家族全員大満足でした。今度はぜひ連泊したいです。広々としていて大きな炬燵でゆったりくつろげました。' },
        en: { date: 'Feb 2025', title: 'Wonderful!!', content: 'We never dreamed we could stay in a Machiya mansion, and the whole family was very satisfied. We want to stay longer next time. It was spacious and we could relax under the large Kotatsu.' }
    },
    {
        score: 10, countryCode: 'ch', guests: 5,
        ja: { date: '2025年11月', title: '美しい伝統的な家', content: '家は美しくモダンに改装されており、広々としたスペースと大きなキッチンを備えています。庭もとても素敵です。バスルームは設備が充実しており、シャワーとバスタブもとても広々としています。' },
        en: { date: 'Nov 2025', title: 'Beautiful Traditional House', content: 'The house is beautifully renovated with modern touches, featuring spacious areas and a large kitchen. The garden is lovely. The bathroom is well-equipped with a very spacious shower and bathtub.' }
    },
    {
        score: 10, countryCode: 'jp', guests: 7,
        ja: { date: '2024年12月', title: '文化と自然を感じれる宿', content: '金沢の町家文化を存分に楽しめる宿泊施設でした。兼六園や21世紀美術館などの観光地にも近く、アクセスの良さが大変便利です。特に印象的だったのは、広々とした庭園です。' },
        en: { date: 'Dec 2024', title: 'Culture and Nature', content: 'An accommodation where you can fully enjoy Kanazawa\'s Machiya culture. Close to Kenrokuen and the 21st Century Museum. The spacious garden was particularly impressive.' }
    },
    {
        score: 10, countryCode: 'jp', guests: 4,
        ja: { date: '2025年2月', title: '最高でした！', content: 'キッチンアイテムも充実していたので、買い物して部屋でゆっくりくつろげました。あえていうなら、フェイスタオルが1人あたりもう1枚ずつあれば助かったかなと思います。' },
        en: { date: 'Feb 2025', title: 'It was the best!', content: 'The kitchen was well-stocked, so we could shop and relax in the room. If I had to say, one more face towel per person would have been helpful.' }
    },
    {
        score: 10, countryCode: 'us', guests: 6,
        ja: { date: '2025年10月', title: '滞在できて幸せでした', content: '古くて広く、美しく改装された家。滞在できて幸せでした。ホストは素晴らしく、コミュニケーションもスムーズでとても親切でした。日本で最高の滞在でした。' },
        en: { date: 'Oct 2025', title: 'A delight to be in', content: 'An old, large and beautifully renovated house. A delight to be in. The host is wonderful. Great communication and really helpful. A terrific stay - the best we have had in Japan.' }
    },
    {
        score: 10, countryCode: 'cn', guests: 5,
        ja: { date: '2025年9月', title: 'お勧めの百年民宿', content: '非常にナイスな管理チームで、トラブルにも迅速に対応してくれました。兼六園などの観光スポットにも非常に近く、本当に美しい場所でした。' },
        en: { date: 'Sep 2025', title: 'Highly Recommended Centennial Inn', content: 'A very nice management team that handled issues effectively. Very close to tourist spots like Kenrokuen, which is truly beautiful.' }
    },
    {
        score: 10, countryCode: 'au', guests: 8,
        ja: { date: '2025年5月', title: '期待以上でした', content: 'オーストラリアからの4人家族での滞在でしたが、この思い出に残る宿泊施設を心から楽しみました。この壮大で本格的な家と、その広さに驚きました。すべてが信じられないほど素晴らしかったです。' },
        en: { date: 'May 2025', title: 'Exceeded our expectations', content: 'My family of four from Australia absolutely loved staying at this memorable accommodation. We loved this grand authentic home and were surprised at how large the home was. Everything about it was just incredible.' }
    },
    {
        score: 10, countryCode: 'jp', guests: 3,
        ja: { date: '2025年4月', title: 'ベストな選択でした', content: '物件は清潔で美しい、立地も素晴らしくスタッフの方の対応も素早くて誠実。両親への感謝の気持ちを伝える旅行でしたがベストな選択でした。ありがとうございました。' },
        en: { date: 'Apr 2025', title: 'The Best Choice', content: 'Clean, beautiful property with a great location and sincere staff. It was a trip to express gratitude to my parents, and this was the best choice. Thank you.' }
    },
    {
        score: 9.0, countryCode: 'jp', guests: 4,
        ja: { date: '2025年4月', title: 'ロケーション抜群', content: '兼六園や21世紀美術館も徒歩圏内でロケーション抜群、部屋も綺麗で広くてよかった。テレビがなかったのが残念だった。' },
        en: { date: 'Apr 2025', title: 'Great Location', content: 'Great location within walking distance of Kenrokuen and the 21st Century Museum. The room was clean and spacious. It was a pity there was no TV.' }
    }
];

const ReviewSlider = ({ isEnglish }) => {
    return (
        <div className="review-slider-container">
            <h2 className="review-section-title">
                {isEnglish ? 'Guestbook' : '芳名帳'}
            </h2>
            <p className="review-section-subtitle">
                {isEnglish ? 'Memories shared by guests from around the world.' : '世界中からお越しいただいたお客様の滞在の記憶'}
            </p>

            <Swiper
                modules={[Pagination, Autoplay, Navigation]}
                spaceBetween={30}
                slidesPerView={1}
                breakpoints={{
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                }}
                pagination={{ clickable: true }}
                navigation
                autoplay={{ delay: 6000, disableOnInteraction: false }}
                loop={true}
                className="review-swiper"
            >
                {reviews.map((review, index) => {
                    const data = isEnglish ? review.en : review.ja;
                    const countryName = getCountryName(review.countryCode, isEnglish);
                    const flagUrl = `https://flagcdn.com/24x18/${review.countryCode.toLowerCase()}.png`;

                    return (
                        <SwiperSlide key={index}>
                            <div className="guestbook-card">
                                {/* 背景に透ける大きな引用符 */}
                                <div className="quote-mark">“</div>

                                <div className="guestbook-content-wrapper">
                                    <h3 className="guestbook-title">{data.title}</h3>
                                    <p className="guestbook-text">{data.content}</p>
                                </div>

                                <div className="guestbook-footer">
                                    <div className="guestbook-score">
                                        <span className="star-icon">★</span> {review.score}
                                    </div>
                                    <div className="guestbook-meta">
                                        <div className="meta-row">
                                            <img
                                                src={flagUrl}
                                                alt={review.countryCode}
                                                className="meta-flag"
                                            />
                                            <span className="meta-country">{countryName}</span>
                                        </div>
                                        <div className="meta-row-sub">
                                            <span>{review.guests} {isEnglish ? 'guests' : '名'}</span>
                                            <span className="meta-dot">・</span>
                                            <span>{data.date}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};

export default ReviewSlider;